import style from './InputSlider.module.css'

interface InputSliderProps {
    value: number
    onChange: (value: number) => void
    options: { name: string }[]
}

const InputSlider = ({ value = 0, onChange, options = [] }: InputSliderProps) => {
    return (
        <div className={style.root}>
            <div className={style.row}>
                {options.map(({ name }, i) => {
                    const isSelected = value === i + 1
                    return (
                        <div
                            className={isSelected ? style.selected : ''}
                            key={i}
                            onClick={() => onChange(i + 1)}>
                            {name}
                        </div>
                    )
                })}
            </div>
            <input
                className={style.slider}
                type="range"
                min="1"
                max={options.length}
                value={value}
                onChange={(event) => onChange(Number(event.target.value))}
            />
        </div>
    )
}

export default InputSlider
